import PageShell from "@/components/layout/PageShell";
import PageCTA from "@/components/sections/PageCTA";
import Portfolio from "@/components/sections/Portfolio";
import Industries from "@/components/sections/Industries";
import Metrics from "@/components/sections/Metrics";
import Testimonials from "@/components/sections/Testimonials";

export default function WorkPage() {
  return (
    <PageShell
      testId="work-page"
      eyebrow="Selected work"
      title={<>Real projects. <span className="text-apex-orange">Real numbers.</span></>}
      subtitle="A snapshot of the design and SEO work APEX Innovation Solutions has shipped for founders, marketing leaders, and small business owners across industries."
      breadcrumbs={[{ label: "Work" }]}
      seoTitle="Case Studies & Portfolio | APEX Innovation Solutions"
      seoDescription="See the web design and SEO work APEX Innovation Solutions has shipped — measurable growth for local businesses, SaaS, DTC, and more."
    >
      <section className="pb-8 md:pb-10 relative">
        <div className="container-apex">
          <p className="text-white/75 leading-relaxed max-w-4xl" data-align-preserve>
            We build websites and SEO systems that produce numbers our clients can point to in a board meeting. Below is a mix of case studies covering local businesses, SaaS founders, and e-commerce brands — with real metrics from the first 90 days after launch.
          </p>
        </div>
      </section>

      <Portfolio />
      <Metrics />
      <Industries />
      <Testimonials />

      <PageCTA
        title="Want a case study like these for your business?"
        subtitle="Every project starts with a free discovery call to align on goals, KPIs, and timeline."
        primary={{ label: "Book a Strategy Call", to: "/contact" }}
        secondary={{ label: "View Services", to: "/services" }}
      />
    </PageShell>
  );
}
